import { render, staticRenderFns } from "./TabAffilifateContent.vue?vue&type=template&id=546c7442&"
import script from "./TabAffilifateContent.vue?vue&type=script&lang=js&"
export * from "./TabAffilifateContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports